/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSlackPersonAccountsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListSlackPersonAccountsRequest = {
  /**
   * Exact Speakeasy user ID of the active organization person.
   */
  userId: string;
  /**
   * Continue after the last membership ID.
   */
  cursor?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListSlackPersonAccountsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSlackPersonAccountsSecurity$outboundSchema: z.ZodMiniType<
  ListSlackPersonAccountsSecurity$Outbound,
  ListSlackPersonAccountsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSlackPersonAccountsSecurityToJSON(
  listSlackPersonAccountsSecurity: ListSlackPersonAccountsSecurity,
): string {
  return JSON.stringify(
    ListSlackPersonAccountsSecurity$outboundSchema.parse(
      listSlackPersonAccountsSecurity,
    ),
  );
}

/** @internal */
export type ListSlackPersonAccountsRequest$Outbound = {
  user_id: string;
  cursor?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSlackPersonAccountsRequest$outboundSchema: z.ZodMiniType<
  ListSlackPersonAccountsRequest$Outbound,
  ListSlackPersonAccountsRequest
> = z.pipe(
  z.object({
    userId: z.string(),
    cursor: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userId: "user_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listSlackPersonAccountsRequestToJSON(
  listSlackPersonAccountsRequest: ListSlackPersonAccountsRequest,
): string {
  return JSON.stringify(
    ListSlackPersonAccountsRequest$outboundSchema.parse(
      listSlackPersonAccountsRequest,
    ),
  );
}
